// extracted by mini-css-extract-plugin
export default {"input":"styles_input__qVTPj","block":"styles_block__HSnKI","error-block":"styles_error-block__hIvCe","error-active":"styles_error-active__Hhvfk","label":"styles_label__msN30"};